const appVersion = process.env.REACT_APP_VERSION;
export default appVersion;